<i18n>
{
    "en_US": {
        "add": "Add",
        "cancel": "Cancel",
        "title-image": "Please enter the image URL",
        "title-link": "Please enter the link URL"
    },
    "fr_FR": {
        "add": "Ajouter",
        "cancel": "Annuler",
        "title-image": "Veuillez entrer l'URL de l'image",
        "title-link": "Veuillez entrer l'URL du lien"
    }
}
</i18n>

<template>
    <div class="upload-menu-container" v-bind:class="{ active: isMenuUploadVisible }">
        <div>
            <p class="text-center muted" v-text="menuUploadType === 'link' ? $t('title-link') : $t('title-image')"></p>

            <link-or-upload v-model="selected" />
        </div>
        <p class="text-center">
            <a class="btn btn-default" v-on:click="hideMenuUpload" v-text="$t('cancel')"></a>
            <button class="btn btn-primary send" v-on:click="add">
                <a v-text="$t('add')"></a>
            </button>
        </p>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import LinkOrUpload from "inputs/LinkOrUpload";
    import event from "plugins/event";

    export default {
        name: "Email",
        data: function() {
            return {
                // The original value used to reset...
                original: "http://",
                // Careful, this could be a string
                // or an HTML5 FileAPI object
                selected: "http://",
                uploader: null
            };
        },
        watch: {
            isMenuUploadVisible: function(value) {
                if (value === true) {
                    // We ask ace editor to save it's current position
                    // (used to know where was the cursor when user ask
                    // to upload a file at this position)
                    event.$emit("ace-editor-save-position");
                    var input = $(this.$el).find("input.form-control");
                    this.selected = this.original;
                    input.focus();
                }
            }
        },
        components: {
            LinkOrUpload
        },
        computed: {
            ...mapState("application", ["isMenuUploadVisible", "menuUploadType"])
        },
        mounted: function() {
            // This uploader will do the job
            this.uploader = new plupload.Uploader({
                url: process.env.VUE_APP_BASE_URL + "/files/upload",
                multi_selection: false,
                browse_button: $(this.$el).find(".btn-upload")[0]
            });

            // Any error
            this.uploader.bind("Error", function(up, error) {
                this.addFlash({
                    type: "error",
                    message: error.message,
                    onlyCurrentRoute: true
                });
            }.bind(this));
        },
        methods: {
            add: function() {
                if (typeof this.selected === "string" && this.selected) {
                    event.$emit("upload-insert-link", this.selected);
                } else if (typeof this.selected === "object" && this.selected != undefined) {
                    this.addUpload(this.selected);
                }
                this.hideMenuUpload();
            },
            ...mapMutations("flash", ["addFlash"]),
            ...mapMutations("upload", ["addUpload"]),
            ...mapMutations("application", ["hideMenuUpload"])
        }
    }
</script>

<style scoped>
    .upload-menu-container {
        display: none;
        position: fixed;
        left: 50%;
        top: 50%;
        height: 190px;
        width: 478px;
        margin-left: -239px;
        margin-top: -95px;
        z-index: 11;
        background: #fff;
        color: #212529;
        padding: 17px;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        -webkit-transition: all .2s ease;
        -moz-transition: all .2s ease;
        -ms-transition: all .2s ease;
        transition: all .2s ease;
    }
    .upload-menu-container.active {
        animation: showSweetAlert .3s;
        display: block;
    }
    .muted {
        color: #6c757d;
        font-weight: 300;
        font-size: 16px;
    }

    .btn-primary, .btn-default {
        text-transform: uppercase;
    }

    @media screen and (max-width: 600px), screen and (max-height: 500px) {
        .upload-menu-container {
            left: 0;
            top: 0;
            height: 100%;
            width: 100%;
            margin-left: 0;
            margin-top: 0;
            -webkit-border-radius: 0px;
            -moz-border-radius: 0px;
            border-radius: 0px;
        }
    }

    /* Spinner */
    .loading {
        padding-top: 50px;
    }
    .btn-primary >>> .loader-basic-spinner div {
        margin: 0;
    }
</style>
